import React, { useEffect, useState } from "react";

import UserLayout from "../../../components/user-layout/UserLayout";
import styles from "./developerProfile.module.scss";
import authService, { user$ } from "../../../utils/services/authService";
import { NavLink } from "react-router-dom";

const DeveloperProfile = () => {
  const [user, setUser] = useState();
  const userData = authService.getUserData();

  useEffect(() => {
    const loggedIn = authService.checkLoggedIn();

    if (loggedIn) {
      if (userData.token !== undefined) {
        authService.getUserById(userData);

        user$.subscribe((data) => {
          if (user !== data) {
            setUser(data.data.data[0]);
          }
        });
      }
    }
  }, []);

  const onDeleteHandle = async (e, jobId) => {
    e.preventDefault();

    const result = await authService.removeApplication(jobId, userData);

    if (result) {
      authService.getUserById(userData);

      user$.subscribe((data) => {
        if (user !== data) {
          setUser(data.data.data[0]);
        }
      });
    }
  };
  return (
    <>
      <UserLayout>
        <section className={styles.devProfileWrapper}>
          <section className={styles.intro}>
            <img
              className={styles.intro_img}
              src={require("../../../assets/images/avatar-big.png")}
              alt=""
            />
            <h2 className={styles.intro_name}>{user?.name}</h2>

            <p className={styles.intro_title}>{user?.profession[0]}</p>
            <p className={styles.intro_bio}>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus
              exercitationem omnis similique distinctio vero. Eius asperiores
              minus voluptates, sit, ut distinctio, molestias perferendis dolore
              adipisci quis optio possimus? Laudantium, voluptate.
            </p>
            <p className={styles.prof}>Proficiencies</p>
            <div className={styles.profWrapper}>
              {user?.skills.map((item, index) => (
                <span key={index} className={styles.profWrapper_item}>
                  {item}
                </span>
              ))}
            </div>

            <p className={styles.socialsTitle}>Socials</p>
            <div className={styles.socials}>
              <a href={user?.socials.github}>
                <img
                  src={require("../../../assets/images/github.png")}
                  alt=""
                />
              </a>
              <a href={user?.socials.linkedIn}>
                <img
                  src={require("../../../assets/images/linkedin.png")}
                  alt=""
                />
              </a>
            </div>
          </section>

          <section className={styles.info}>
            <div className={styles.item}>
              <p className={styles.item_title}>Current location</p>
              <p className={styles.item_value}>{user?.location}</p>
            </div>
            <div className={styles.item}>
              <p className={styles.item_title}>Languages</p>
              <p className={styles.item_value}>
                {user?.languages[0]}, {user?.languages[1]}
              </p>
            </div>
            <div className={styles.item}>
              <p className={styles.item_title}>Education</p>
              <p className={styles.item_school}>{user?.education}</p>
            </div>
            <div className={styles.item}>
              <p className={styles.item_title}>Gender</p>
              <p className={styles.item_value}>{user?.gender}</p>
            </div>
          </section>

          <section className={styles.prefWrapper}>
            <h3 className={styles.prefWrapper_title}>Preferences</h3>
            <div className={styles.prefInner}>
              <div className={styles.prefItem}>
                <img
                  src={require("../../../assets/images/salary.png")}
                  alt=""
                />
                <p className={styles.prefItem_title}>Salary</p>
                <p className={styles.prefItem_value}>
                  {user?.preferences.minSalary}
                </p>
              </div>
              <div className={styles.prefItem}>
                <img src={require("../../../assets/images/globe.png")} alt="" />
                <p className={styles.prefItem_title}>Remote</p>
                <p className={styles.prefItem_value}>
                  {user?.preferences.officePref.map((item, index) => (
                    <span key={index}>{item}, </span>
                  ))}
                </p>
              </div>
              <div className={styles.prefItem}>
                <img src={require("../../../assets/images/roles.png")} alt="" />
                <p className={styles.prefItem_title}>Roles</p>
                <p className={styles.prefItem_value}>
                  {user?.preferences.role.map((item, index) => (
                    <span key={index}>{item}, </span>
                  ))}
                </p>
              </div>
              <div className={styles.prefItem}>
                <img
                  src={require("../../../assets/images/job-types.png")}
                  alt=""
                />
                <p className={styles.prefItem_title}>Job types</p>
                <p className={styles.prefItem_value}>
                  {user?.preferences.jobTypes.map((item, index) => (
                    <span key={index}>{item}, </span>
                  ))}
                </p>
              </div>
              <div className={styles.prefItem}>
                <img src={require("../../../assets/images/stars.png")} alt="" />
                <p className={styles.prefItem_title}>Location of interest</p>
                <p className={styles.prefItem_value}>
                  {user?.preferences.locations.map((item, index) => (
                    <span key={index}>{item}, </span>
                  ))}
                </p>
              </div>
            </div>
          </section>
          <section className={styles.appliedJobs}>
            <h3>Applied jobs</h3>
            <div className={styles.inner}>
              {user?.appliedJobs.map((job, index) => (
                <div key={index} className={styles.jobCard}>
                  <h4>{job.title}</h4>
                  <div className={styles.btnWrapper}>
                    <NavLink
                      to={`/job/${job._id}`}
                      className={styles.btnWrapper_btn}
                    >
                      View job
                    </NavLink>
                    <button
                      className={styles.btnWrapper_deleteBtn}
                      onClick={(e) => {
                        onDeleteHandle(e, job._id);
                      }}
                    >
                      Revoke application
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </section>
      </UserLayout>
    </>
  );
};

export default DeveloperProfile;
